<template>
  <v-list-item
    class="my-0"
    :class="styling"
    :disabled="!to"
    :to="to"
  >
    <v-list-item-icon>
      <v-icon
        :color="color"
        left
        size="18"
      >
        {{ icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        <span v-text="title" />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'BaseDrawerMenuItem',
  props: {
    color: {
      type: String,
      default: 'blue-grey',
      note: 'The item\'s color',
    },
    icon: {
      type: String,
      default: undefined,
      note: 'The item\'s image',
    },
    styling: {
      type: String,
      default: '',
      note: 'The item\'s style',
    },
    title: {
      type: String,
      required: true,
      note: 'The item\'s label',
    },
    to: {
      type: Object,
      default: () => null,
      note: 'The item\'s link',
    },
  },
};
</script>
